/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface POAMItemUpdateRequest
 */
export interface POAMItemUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof POAMItemUpdateRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemUpdateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemUpdateRequest
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof POAMItemUpdateRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof POAMItemUpdateRequest
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemUpdateRequest
     */
    budget?: string;
}

/**
 * Check if a given object implements the POAMItemUpdateRequest interface.
 */
export function instanceOfPOAMItemUpdateRequest(value: object): value is POAMItemUpdateRequest {
    return true;
}

export function POAMItemUpdateRequestFromJSON(json: any): POAMItemUpdateRequest {
    return POAMItemUpdateRequestFromJSONTyped(json, false);
}

export function POAMItemUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): POAMItemUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': json['status'] == null ? undefined : json['status'],
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'budget': json['budget'] == null ? undefined : json['budget'],
    };
}

export function POAMItemUpdateRequestToJSON(json: any): POAMItemUpdateRequest {
    return POAMItemUpdateRequestToJSONTyped(json, false);
}

export function POAMItemUpdateRequestToJSONTyped(value?: POAMItemUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'status': value['status'],
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'remarks': value['remarks'],
        'budget': value['budget'],
    };
}

